module.exports = __webpack_public_path__ + "static/marketingProOverviewHeroVideo-5680de8daced46821fb041fc3d248e0f.mp4";